import React from 'react'

const MultiplicativeCipherDecryption = ({ plainText, cipherText, plainPos, shift }) => {

    var plainTextArray = plainText.split("");
    var cipherTextArray = cipherText.split("");
    var plainPosArray = plainPos.split("#").filter(function (el) { return el.length !== 0 });

    function find_mod_inv(a, m) {
        for (let x = 1; x < m; x++) {
            if ((a % m) * (x % m) % m === 1) {
                return x;
            }
        }
        return 0
    }

    return (
        <div>
            <p style={{ textAlign: "left", fontSize: "20px", fontWeight: "bold", margin: "40px 0 10px 0" }}>Decryption</p>

            <div style={{ textAlign: "left", display: "flex" }}>
                <div style={{ display: "inline", textAlign: "right", minWidth: "13rem" }}>
                    <div>
                        <p style={{ display: "inline" }}>Cipher Text:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Position:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Key:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Key_Inverse:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Pos * Key_Inverse:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Mod 26:</p>
                    </div>
                    <div>
                        <p style={{ display: "inline" }}>Plain Text:</p>
                    </div>
                </div>
                <div style={{ display: "inline" }}>
                    <div className='wrapper'>
                        {cipherTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {plainPosArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{(parseInt(ch) * parseInt(shift)) % 26}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {plainPosArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{shift}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {plainPosArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{find_mod_inv(shift, 26)}</div>
                        ))}
                    </div>

                    <div className='wrapper'>
                        {plainPosArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{((((parseInt(ch) * parseInt(shift)) % 26) * find_mod_inv(shift, 26)))}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {plainPosArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{( (((parseInt(ch) * parseInt(shift)) % 26) * find_mod_inv(shift, 26)) % 26 )}</div>
                        ))}
                    </div>
                    <div className='wrapper'>
                        {plainTextArray.map((ch) => (
                            <div key={Math.random()} style={{ display: "inline-block", width: "80px", margin: 0, textAlign: "center" }}>{ch}</div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MultiplicativeCipherDecryption